<script>
export default {
  props: {
    pricingData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      isHide: true,
    };
  },
  methods: {
    getItemData (items) {
      if (this.isHide) {
        return items.slice(0, 5)
      }
      return items
    }
  }
};
</script>

<template>
  <div class="row price-wrap">
    <div
      class="col-md-3 col-12 price-item"
      v-for="(item, index) of pricingData"
      :key="index"
    >
      <div
        class="card"
      >
        <div class="card-top">
          <img :src="item.star" alt="star" class="img-fixed" />
          <svg class="top" width="100%" viewBox="0 0 285 187" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <path d="M183 18C183 27.9411 191.059 36 201 36H257C272.464 36 285 48.536 285 64V179C285 194.464 272.464 207 257 207H28C12.536 207 0 194.464 0 179V28C0 12.536 12.536 0 28 0H165C174.941 0 183 8.05888 183 18Z" :fill="`url(#paint0_linear_14_976${item.id})`"/>
            <defs>
              <linearGradient :id="`paint0_linear_14_976${item.id}`" x1="142.5" y1="0" x2="142.5" y2="187" gradientUnits="userSpaceOnUse">
              <stop :stop-color="item.topColor[0]"/>
              <stop offset="1" :stop-color="item.topColor[1]"/>
              </linearGradient>
            </defs>
          </svg>
          <img src="@/assets/images/price/polygon.png" class="polygon" alt="polygon" />

          <h6 class="flow-number">
            {{ item.title }}
          </h6>

          <div class="tag">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.97179 2.37509C7.43818 1.60011 8.56174 1.60011 9.02813 2.37509L10.1517 4.24201C10.3192 4.52042 10.5925 4.71899 10.9091 4.7923L13.0318 5.28393C13.913 5.48801 14.2602 6.55658 13.6672 7.23963L12.2389 8.88507C12.0259 9.13046 11.9215 9.45174 11.9496 9.77547L12.138 11.9462C12.2162 12.8473 11.3072 13.5078 10.4744 13.1549L8.46807 12.3049C8.16887 12.1782 7.83105 12.1782 7.53185 12.3049L5.52555 13.1549C4.69271 13.5078 3.78373 12.8473 3.86194 11.9462L4.05033 9.77547C4.07843 9.45174 3.97404 9.13046 3.76102 8.88508L2.33267 7.23963C1.73974 6.55658 2.08694 5.48801 2.96811 5.28393L5.09085 4.7923C5.40741 4.71899 5.68071 4.52042 5.84826 4.24201L6.97179 2.37509Z" fill="url(#paint0_linear_14_985)"/>
              <defs>
              <linearGradient id="paint0_linear_14_985" x1="7.88879" y1="8.99996" x2="4.22213" y2="5.66663" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F8BB25"/>
              <stop offset="1" stop-color="#F8E571"/>
              </linearGradient>
              </defs>
            </svg>

            {{ item.tag }}
          </div>
        </div>

        <div class="card-body">
          <ul class="list-unstyled mb-0 pl-0">
            <li
              v-for="(feature, index) in getItemData(item.feature)"
              :key="index"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.2343 4.3222C14.6248 4.71272 14.6248 5.34589 14.2343 5.73641L7.65697 12.3138C7.29093 12.6798 6.71149 12.7029 6.31872 12.3828L6.24276 12.3138L2.87779 8.94878C2.48737 8.55825 2.4873 7.92505 2.87779 7.53456C3.26829 7.1442 3.90151 7.14418 4.292 7.53456L6.94987 10.1924L12.8201 4.3222C13.2106 3.9317 13.8438 3.93169 14.2343 4.3222Z" fill="url(#paint0_linear_14_994)"/>
                <defs>
                <linearGradient id="paint0_linear_14_994" x1="6.85647" y1="4.66753" x2="7.18766" y2="9.36084" gradientUnits="userSpaceOnUse">
                <stop stop-color="#55EE94"/>
                <stop offset="1" stop-color="#1CC841"/>
                </linearGradient>
                </defs>
              </svg>

              {{ feature }}
            </li>
          </ul>
          <div class="view-more-wrap" @click="isHide = !isHide">
            <template v-if="isHide">
              {{ $t('更多') }}

              <i class="uil uil-arrow-down"></i>
            </template>
            <template v-else>
              {{ $t('收起') }}

              <i class="uil uil-arrow-up"></i>
            </template>
          </div>

          <div :style="`color: ${item.priceColor}`" class="d-flex justify-content-start mb-2 mt-2">
            <!-- <span class="h4 mb-0 mt-2">S$</span> -->
            <span class="unit">
              S$
            </span>
            <span v-if="Number(item.price) !== item.originPrice" class="price-old">{{ item.originPrice }}</span>
            <span class="price-new">{{ item.price }}</span>
            <span class="h4 align-self-end mb-1">/mo</span>
          </div>

          <a href="javascript:void(0)" :style="item.btnColor" class="buy-btn" @click="$router.push({ path: '/order', query: { plan: item.id, } })">{{
            item.button
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.price-wrap {
  .price-item {
    padding-left: 17.5px!important;
    padding-right: 17.5px!important;
  }

  .flow-number {
    font-size: 56px!important;
    position: absolute;
    left: 16px;
    top: 4px;
    font-weight: bold;
    color: #fff;
  }

  .tag {
    position: absolute;
    top: 100px;
    left: 16px;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    font-size: 12px;
    line-height: 1.75;
    border-radius: 4px;
    background: #fff;

    svg {
      margin-right: 4px;
    }
  }

  .card-top {
    aspect-ratio: 285/187;
    position: relative;
  }

  .card {
    position: relative;
    border: none;
    overflow: hidden;
    padding-top: 16px;
    .img-fixed {
      width: 80px;
      position: absolute;
      right: 16px;
      top: -12px;
    }

    .polygon {
      position: absolute;
      width: 239px;
      right: -12px;
      top: 50px;
    }
  }

  .card-body {
    position: relative;
    margin-top: -48px;
    border: 2px solid rgba(244,251,253,0.6);
    // border-image-source: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%);
    // border-image-slice: 1;
    // background-clip: padding-box;
    background: #BAE9F529;
    backdrop-filter: blur(51.20000076293945px);
    border-radius: 20px;
    overflow: hidden;

    .list-unstyled {
      li {
        display: flex;
        align-items: baseline;
        gap: 6px;
        color: rgba(81, 98, 113, 1);

        svg {
          min-width: 16px;
          transform: translateY(3px);
        }

        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }

    .unit {
      font-size: 32px;
    }

    .price-old {
      font-size: 32px;
      text-decoration: line-through;
      margin-left: 4px;
      margin-right: 8px;
      opacity: 0.4;
    }

    .price-new {
      font-size: 32px;
    }

    .buy-btn {
      color: #fff;
      font-size: 16px;
      border: none;
      width: 100%;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      transition: all 0.3s;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.view-more-wrap {
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  color: #2F55D4;
  i {
    font-size: 20px;
  }
  &:hover {
    color: var(--primary)!important;
    i {
      color: var(--primary);
    }
  }
}
</style>